export const BPM_RANGES = ['60 - 79', '80 - 99', '100 - 114', '115 - 130', '130 - 139', '140 - 159', '160 - 180'];
